import { ComponentProps } from 'react';
import { Button, cn } from '@bliks-io/ui';

/**
 * Compact 30px outline button for the draft-table header toolbar — the
 * package's small Button is 44px, the design's table toolbar is a pill row.
 */
export function TableToolbarButton({ className, ...props }: ComponentProps<typeof Button>) {
  return (
    <Button
      variant="outline"
      size="small"
      className={cn('h-[30px] rounded-lg px-3 text-[12.5px]', className)}
      {...props}
    />
  );
}
